function accordion($ele, only_mobile) {
  $($ele).on("click", function() {
    const $this = $(this);
    if (only_mobile && $(window).width() > 767) {
      return;
    }
    const $accordion = $this.closest(".accordion");
    $accordion.toggleClass("active");
    $accordion.find(".accordion__content").slideToggle();
  });
}

module.exports = {
  accordion
};



// WEBPACK FOOTER //
// ../assets/js/accordion.js